import React, { useState } from 'react';
import { Header } from '../components/Header';
import { Footer } from '../components/Footer';
import { ChevronDownIcon } from 'lucide-react';
export function ThresholdsPage() {
  const [selectedDivision, setSelectedDivision] = useState('Junior Level');
  const divisions = ['Junior Level', 'Senior Level', 'Cadet Level', 'Kids Level', 'W.T.F. Olympic Category', 'W.T.F. Para Taekwondo'];
  const maleData = [{
    category: '- 45 Kg / 99 lbs',
    size: '#1',
    level: '22'
  }, {
    category: '- 48 Kg / 106 lbs',
    size: '#2',
    level: '23'
  }, {
    category: '- 51 Kg / 112 lbs',
    size: '#2',
    level: '24'
  }, {
    category: '- 55 Kg / 121 lbs',
    size: '#2',
    level: '25'
  }, {
    category: '- 59 Kg / 130 lbs',
    size: '#3',
    level: '27'
  }, {
    category: '- 63 Kg / 139 lbs',
    size: '#3',
    level: '28'
  }, {
    category: '- 68 Kg / 150 lbs',
    size: '#3',
    level: '30'
  }, {
    category: '- 73 Kg / 161 lbs',
    size: '#3',
    level: '32'
  }, {
    category: '- 78 Kg / 172 lbs',
    size: '#4',
    level: '33'
  }, {
    category: '+ 78 Kg / 172 lbs',
    size: '#4',
    level: '34'
  }];
  const femaleData = [{
    category: '- 42 Kg / 93 lbs',
    size: '#1',
    level: '20'
  }, {
    category: '- 44 Kg / 97 lbs',
    size: '#1',
    level: '21'
  }, {
    category: '- 46 Kg / 101 lbs',
    size: '#1',
    level: '22'
  }, {
    category: '- 49 Kg / 108 lbs',
    size: '#2',
    level: '22'
  }, {
    category: '- 52 Kg / 115 lbs',
    size: '#2',
    level: '23'
  }, {
    category: '- 55 Kg / 121 lbs',
    size: '#2',
    level: '24'
  }, {
    category: '- 59 Kg / 130 lbs',
    size: '#3',
    level: '25'
  }, {
    category: '- 63 Kg / 139 lbs',
    size: '#3',
    level: '26'
  }, {
    category: '- 68 Kg / 150 lbs',
    size: '#3',
    level: '28'
  }, {
    category: '+ 68 Kg / 150 lbs',
    size: '#4',
    level: '30'
  }];
  const seniorMaleData = [{
    weight: 'FIN',
    category: '- 54 Kg / 119 lbs',
    size: '#2',
    level: '26'
  }, {
    weight: 'FLY',
    category: '- 58 Kg / 128 lbs',
    size: '#3',
    level: '30'
  }, {
    weight: 'BANTAM',
    category: '- 63 Kg / 139 lbs',
    size: '#3',
    level: '31'
  }, {
    weight: 'FEATHER',
    category: '- 68 Kg / 159 lbs',
    size: '#3',
    level: '32'
  }, {
    weight: 'LIGHT',
    category: '- 74 Kg / 163 lbs',
    size: '#3',
    level: '33'
  }, {
    weight: 'WELTER',
    category: '- 80 Kg / 176 lbs',
    size: '#4',
    level: '34'
  }, {
    weight: 'MIDDLE',
    category: '- 87 Kg / 192 lbs',
    size: '#4',
    level: '36'
  }, {
    weight: 'HEAVY',
    category: '+ 87 Kg / 192 lbs',
    size: '#4/5',
    level: '38'
  }];
  const seniorFemaleData = [{
    weight: 'FIN',
    category: '- 46 Kg / 101 lbs',
    size: '#1',
    level: '22'
  }, {
    weight: 'FLY',
    category: '- 49 Kg / 108 lbs',
    size: '#2',
    level: '25'
  }, {
    weight: 'BANTAM',
    category: '- 53 Kg / 117 lbs',
    size: '#2',
    level: '26'
  }, {
    weight: 'FEATHER',
    category: '- 57 Kg / 126 lbs',
    size: '#3',
    level: '27'
  }, {
    weight: 'LIGHT',
    category: '- 62 Kg / 137 lbs',
    size: '#3',
    level: '28'
  }, {
    weight: 'WELTER',
    category: '- 67 Kg / 148 lbs',
    size: '#3',
    level: '30'
  }, {
    weight: 'MIDDLE',
    category: '- 73 Kg / 161 lbs',
    size: '#3',
    level: '31'
  }, {
    weight: 'HEAVY',
    category: '+ 73 Kg / 161 lbs',
    size: '#4',
    level: '32'
  }];
  const cadetMaleData = [{
    category: '- 33 Kg / 73 lbs',
    size: '#0',
    level: '17'
  }, {
    category: '- 37 Kg / 82 lbs',
    size: '#0',
    level: '18'
  }, {
    category: '- 41 Kg / 90 lbs',
    size: '#1',
    level: '19'
  }, {
    category: '- 45 Kg / 99 lbs',
    size: '#1',
    level: '21'
  }, {
    category: '- 49 Kg / 108 lbs',
    size: '#2',
    level: '22'
  }, {
    category: '- 53 Kg / 117 lbs',
    size: '#2',
    level: '24'
  }, {
    category: '- 57 Kg / 126 lbs',
    size: '#2',
    level: '25'
  }, {
    category: '- 61 Kg / 134 lbs',
    size: '#3',
    level: '27'
  }, {
    category: '- 65 Kg / 143 lbs',
    size: '#3',
    level: '28'
  }, {
    category: '+ 65 Kg / 143 lbs',
    size: '#3',
    level: '30'
  }];
  const cadetFemaleData = [{
    category: '- 29 Kg / 64 lbs',
    size: '#0',
    level: '16'
  }, {
    category: '- 33 Kg / 73 lbs',
    size: '#0',
    level: '17'
  }, {
    category: '- 37 Kg / 82 lbs',
    size: '#0',
    level: '18'
  }, {
    category: '- 41 Kg / 90 lbs',
    size: '#1',
    level: '19'
  }, {
    category: '- 44 Kg / 97 lbs',
    size: '#1',
    level: '20'
  }, {
    category: '- 47 Kg / 104 lbs',
    size: '#2',
    level: '21'
  }, {
    category: '- 51 Kg / 112 lbs',
    size: '#2',
    level: '22'
  }, {
    category: '- 55 Kg / 121 lbs',
    size: '#2',
    level: '23'
  }, {
    category: '- 59 Kg / 130 lbs',
    size: '#3',
    level: '24'
  }, {
    category: '+ 59 Kg / 130 lbs',
    size: '#3',
    level: '25'
  }];
  const kids6to7Data = [{
    category: '- 19 Kg',
    size: '#00',
    level: '6'
  }, {
    category: '- 23 Kg',
    size: '#00',
    level: '6'
  }, {
    category: '- 27 Kg',
    size: '#00',
    level: '6'
  }, {
    category: '+ 27 Kg',
    size: '#00',
    level: '6'
  }];
  const kids8to9Data = [{
    category: '- 21 Kg',
    size: '#00',
    level: '8'
  }, {
    category: '- 25 Kg',
    size: '#00',
    level: '10'
  }, {
    category: '- 30 Kg',
    size: '#00',
    level: '12'
  }, {
    category: '+ 30 Kg',
    size: '#0',
    level: '14'
  }];
  const kids10to11Data = [{
    category: '- 30 Kg',
    size: '#00',
    level: '12'
  }, {
    category: '- 35 Kg',
    size: '#0',
    level: '14'
  }, {
    category: '- 40 Kg',
    size: '#0',
    level: '16'
  }, {
    category: '+ 40 Kg',
    size: '#1',
    level: '12'
  }];
  const olympicMaleData = [{
    category: '- 58 Kg / 128 lbs',
    size: '#3',
    level: '30'
  }, {
    category: '+ 58/-68 Kg / 128/150 lbs',
    size: '#3',
    level: '32'
  }, {
    category: '+68/-80 Kg / 150/176 lbs',
    size: '#4',
    level: '34'
  }, {
    category: '+ 80 Kg / 176 lbs',
    size: '#5',
    level: '36'
  }];
  const olympicFemaleData = [{
    category: '- 49 Kg / 108 lbs',
    size: '#2',
    level: '25'
  }, {
    category: '+ 49/-57 Kg / 108/126 lbs',
    size: '#2',
    level: '27'
  }, {
    category: '+ 57/-67 Kg / -126/148 lbs',
    size: '#3',
    level: '30'
  }, {
    category: '+ 67 Kg / 148 lbs',
    size: '#3',
    level: '32'
  }];
  const paraMaleData = [{
    category: '- 58 Kg / 128 lbs',
    size: '#3',
    level: '20'
  }, {
    category: '+ 58/-68 Kg / 128 /150 lbs',
    size: '#3',
    level: '22'
  }, {
    category: '+ 68/-80 Kg / 150 /176 lbs',
    size: '#4',
    level: '24'
  }, {
    category: '+ 80 Kg / 176 lbs',
    size: '#5',
    level: '26'
  }];
  const paraFemaleData = [{
    category: '- 49 Kg / 108 lbs',
    size: '#2',
    level: '18'
  }, {
    category: '+ 49 /-57 Kg / 108 /126 lbs',
    size: '#2',
    level: '19'
  }, {
    category: '+ 57 /-67 Kg / 126 /148 lbs',
    size: '#3',
    level: '20'
  }, {
    category: '+ 67 Kg / 148 lbs',
    size: '#3',
    level: '22'
  }];
  return <div className="min-h-screen bg-gray-50 flex flex-col" data-id="element-936">
      <Header data-id="element-937" />

      <main className="flex-grow pt-32 pb-20" data-id="element-938">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-939">
          {/* Page Header */}
          <div className="text-center mb-10" data-id="element-940">
            <h1 className="text-3xl md:text-4xl font-black text-gray-900 uppercase tracking-tight mb-3" data-id="element-941">
              Thresholds / Hit Levels
            </h1>
            <p className="text-lg text-gray-600 uppercase tracking-wide font-medium" data-id="element-942">
              DAEDO - EP SYSTEM, SIZE & LEVEL
            </p>
          </div>

          {/* Division Selector */}
          <div className="max-w-md mx-auto mb-12" data-id="element-943">
            <label htmlFor="division-select" className="block text-sm font-bold text-gray-700 mb-2 text-center uppercase tracking-wider" data-id="element-944">
              Select Division
            </label>
            <div className="relative" data-id="element-945">
              <select id="division-select" value={selectedDivision} onChange={e => setSelectedDivision(e.target.value)} className="block w-full appearance-none bg-white border border-gray-300 text-gray-900 py-3 px-4 pr-8 rounded-lg shadow-sm focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-blue-500 font-semibold text-lg cursor-pointer transition-colors hover:border-blue-400" data-id="element-946">
                {divisions.map(division => <option key={division} value={division} data-id="element-947">
                    {division}
                  </option>)}
              </select>
              <div className="pointer-events-none absolute inset-y-0 right-0 flex items-center px-4 text-gray-500" data-id="element-948">
                <ChevronDownIcon className="h-5 w-5" data-id="element-949" />
              </div>
            </div>
          </div>

          {/* Content Area */}
          {selectedDivision === 'Junior Level' ? <div className="space-y-12" data-id="element-950">
              {/* Junior Male Section */}
              <div className="bg-white rounded-xl shadow-sm border border-gray-200 overflow-hidden" data-id="element-951">
                <div className="bg-blue-600 px-6 py-4" data-id="element-952">
                  <h2 className="text-xl font-bold text-white uppercase tracking-wide" data-id="element-953">
                    Junior MALE (남자)
                  </h2>
                </div>
                <div data-id="element-954">
                  <table className="w-full text-xs md:text-sm text-center table-fixed" data-id="element-955">
                    <tbody data-id="element-956">
                      <tr className="border-b border-gray-200 bg-gray-50" data-id="element-957">
                        <td className="px-2 py-3 font-bold text-gray-700 text-left w-20 md:w-28 border-r border-gray-200" data-id="element-958">
                          Category
                        </td>
                        {maleData.map((item, index) => <td key={index} className="px-1 py-3 text-gray-600 font-medium" data-id="element-959">
                            {item.category}
                          </td>)}
                      </tr>
                      <tr className="border-b border-gray-200" data-id="element-960">
                        <td className="px-2 py-3 font-bold text-gray-700 text-left bg-gray-50 w-20 md:w-28 border-r border-gray-200" data-id="element-961">
                          Size EBP
                        </td>
                        {maleData.map((item, index) => <td key={index} className="px-1 py-3 font-bold text-red-600 text-sm md:text-lg" data-id="element-962">
                            {item.size}
                          </td>)}
                      </tr>
                      <tr className="bg-gray-50" data-id="element-963">
                        <td className="px-2 py-3 font-bold text-gray-700 text-left w-20 md:w-28 border-r border-gray-200" data-id="element-964">
                          LEVEL
                        </td>
                        {maleData.map((item, index) => <td key={index} className="px-1 py-3 font-bold text-gray-900 text-sm md:text-lg" data-id="element-965">
                            {item.level}
                          </td>)}
                      </tr>
                    </tbody>
                  </table>
                </div>
              </div>

              {/* Junior Female Section */}
              <div className="bg-white rounded-xl shadow-sm border border-gray-200 overflow-hidden" data-id="element-966">
                <div className="bg-pink-600 px-6 py-4" data-id="element-967">
                  <h2 className="text-xl font-bold text-white uppercase tracking-wide" data-id="element-968">
                    Junior FEMALE (여자)
                  </h2>
                </div>
                <div data-id="element-969">
                  <table className="w-full text-xs md:text-sm text-center table-fixed" data-id="element-970">
                    <tbody data-id="element-971">
                      <tr className="border-b border-gray-200 bg-gray-50" data-id="element-972">
                        <td className="px-2 py-3 font-bold text-gray-700 text-left w-20 md:w-28 border-r border-gray-200" data-id="element-973">
                          Category
                        </td>
                        {femaleData.map((item, index) => <td key={index} className="px-1 py-3 text-gray-600 font-medium" data-id="element-974">
                            {item.category}
                          </td>)}
                      </tr>
                      <tr className="border-b border-gray-200" data-id="element-975">
                        <td className="px-2 py-3 font-bold text-gray-700 text-left bg-gray-50 w-20 md:w-28 border-r border-gray-200" data-id="element-976">
                          Size EBP
                        </td>
                        {femaleData.map((item, index) => <td key={index} className="px-1 py-3 font-bold text-red-600 text-sm md:text-lg" data-id="element-977">
                            {item.size}
                          </td>)}
                      </tr>
                      <tr className="bg-gray-50" data-id="element-978">
                        <td className="px-2 py-3 font-bold text-gray-700 text-left w-20 md:w-28 border-r border-gray-200" data-id="element-979">
                          LEVEL
                        </td>
                        {femaleData.map((item, index) => <td key={index} className="px-1 py-3 font-bold text-gray-900 text-sm md:text-lg" data-id="element-980">
                            {item.level}
                          </td>)}
                      </tr>
                    </tbody>
                  </table>
                </div>
              </div>
            </div> : selectedDivision === 'Senior Level' ? <div className="space-y-12" data-id="element-981">
              {/* Senior Male Section */}
              <div className="bg-white rounded-xl shadow-sm border border-gray-200 overflow-hidden" data-id="element-982">
                <div className="bg-blue-600 px-6 py-4" data-id="element-983">
                  <h2 className="text-xl font-bold text-white uppercase tracking-wide" data-id="element-984">
                    Senior MALE (남자)
                  </h2>
                </div>
                <div data-id="element-985">
                  <table className="w-full text-xs md:text-sm text-center table-fixed" data-id="element-986">
                    <tbody data-id="element-987">
                      <tr className="border-b border-gray-200 bg-blue-50" data-id="element-988">
                        <td className="px-2 py-3 font-bold text-gray-700 text-left w-20 md:w-28 border-r border-gray-200" data-id="element-989"></td>
                        {seniorMaleData.map((item, index) => <td key={index} className="px-1 py-3 font-bold text-red-600" data-id="element-990">
                            {item.weight}
                          </td>)}
                      </tr>
                      <tr className="border-b border-gray-200 bg-gray-50" data-id="element-991">
                        <td className="px-2 py-3 font-bold text-gray-700 text-left w-20 md:w-28 border-r border-gray-200" data-id="element-992">
                          Category
                        </td>
                        {seniorMaleData.map((item, index) => <td key={index} className="px-1 py-3 text-gray-600 font-medium" data-id="element-993">
                            {item.category}
                          </td>)}
                      </tr>
                      <tr className="border-b border-gray-200" data-id="element-994">
                        <td className="px-2 py-3 font-bold text-gray-700 text-left bg-gray-50 w-20 md:w-28 border-r border-gray-200" data-id="element-995">
                          Size EBP
                        </td>
                        {seniorMaleData.map((item, index) => <td key={index} className="px-1 py-3 font-bold text-red-600 text-sm md:text-lg" data-id="element-996">
                            {item.size}
                          </td>)}
                      </tr>
                      <tr className="bg-gray-50" data-id="element-997">
                        <td className="px-2 py-3 font-bold text-gray-700 text-left w-20 md:w-28 border-r border-gray-200" data-id="element-998">
                          LEVEL
                        </td>
                        {seniorMaleData.map((item, index) => <td key={index} className="px-1 py-3 font-bold text-gray-900 text-sm md:text-lg" data-id="element-999">
                            {item.level}
                          </td>)}
                      </tr>
                    </tbody>
                  </table>
                </div>
              </div>

              {/* Senior Female Section */}
              <div className="bg-white rounded-xl shadow-sm border border-gray-200 overflow-hidden" data-id="element-1000">
                <div className="bg-pink-600 px-6 py-4" data-id="element-1001">
                  <h2 className="text-xl font-bold text-white uppercase tracking-wide" data-id="element-1002">
                    Senior FEMALE (여자)
                  </h2>
                </div>
                <div data-id="element-1003">
                  <table className="w-full text-xs md:text-sm text-center table-fixed" data-id="element-1004">
                    <tbody data-id="element-1005">
                      <tr className="border-b border-gray-200 bg-pink-50" data-id="element-1006">
                        <td className="px-2 py-3 font-bold text-gray-700 text-left w-20 md:w-28 border-r border-gray-200" data-id="element-1007"></td>
                        {seniorFemaleData.map((item, index) => <td key={index} className="px-1 py-3 font-bold text-red-600" data-id="element-1008">
                            {item.weight}
                          </td>)}
                      </tr>
                      <tr className="border-b border-gray-200 bg-gray-50" data-id="element-1009">
                        <td className="px-2 py-3 font-bold text-gray-700 text-left w-20 md:w-28 border-r border-gray-200" data-id="element-1010">
                          Category
                        </td>
                        {seniorFemaleData.map((item, index) => <td key={index} className="px-1 py-3 text-gray-600 font-medium" data-id="element-1011">
                            {item.category}
                          </td>)}
                      </tr>
                      <tr className="border-b border-gray-200" data-id="element-1012">
                        <td className="px-2 py-3 font-bold text-gray-700 text-left bg-gray-50 w-20 md:w-28 border-r border-gray-200" data-id="element-1013">
                          Size EBP
                        </td>
                        {seniorFemaleData.map((item, index) => <td key={index} className="px-1 py-3 font-bold text-red-600 text-sm md:text-lg" data-id="element-1014">
                            {item.size}
                          </td>)}
                      </tr>
                      <tr className="bg-gray-50" data-id="element-1015">
                        <td className="px-2 py-3 font-bold text-gray-700 text-left w-20 md:w-28 border-r border-gray-200" data-id="element-1016">
                          LEVEL
                        </td>
                        {seniorFemaleData.map((item, index) => <td key={index} className="px-1 py-3 font-bold text-gray-900 text-sm md:text-lg" data-id="element-1017">
                            {item.level}
                          </td>)}
                      </tr>
                    </tbody>
                  </table>
                </div>
              </div>
            </div> : selectedDivision === 'Cadet Level' ? <div className="space-y-12" data-id="element-1018">
              {/* Cadet Male Section */}
              <div className="bg-white rounded-xl shadow-sm border border-gray-200 overflow-hidden" data-id="element-1019">
                <div className="bg-blue-600 px-6 py-4" data-id="element-1020">
                  <h2 className="text-xl font-bold text-white uppercase tracking-wide" data-id="element-1021">
                    Cadet MALE
                  </h2>
                </div>
                <div data-id="element-1022">
                  <table className="w-full text-xs md:text-sm text-center table-fixed" data-id="element-1023">
                    <tbody data-id="element-1024">
                      <tr className="border-b border-gray-200 bg-gray-50" data-id="element-1025">
                        <td className="px-2 py-3 font-bold text-gray-700 text-left w-20 md:w-28 border-r border-gray-200" data-id="element-1026">
                          Category
                        </td>
                        {cadetMaleData.map((item, index) => <td key={index} className="px-1 py-3 text-gray-600 font-medium" data-id="element-1027">
                            {item.category}
                          </td>)}
                      </tr>
                      <tr className="border-b border-gray-200" data-id="element-1028">
                        <td className="px-2 py-3 font-bold text-gray-700 text-left bg-gray-50 w-20 md:w-28 border-r border-gray-200" data-id="element-1029">
                          Size
                        </td>
                        {cadetMaleData.map((item, index) => <td key={index} className="px-1 py-3 font-bold text-red-600 text-sm md:text-lg" data-id="element-1030">
                            {item.size}
                          </td>)}
                      </tr>
                      <tr className="bg-gray-50" data-id="element-1031">
                        <td className="px-2 py-3 font-bold text-gray-700 text-left w-20 md:w-28 border-r border-gray-200" data-id="element-1032">
                          LEVEL
                        </td>
                        {cadetMaleData.map((item, index) => <td key={index} className="px-1 py-3 font-bold text-gray-900 text-sm md:text-lg" data-id="element-1033">
                            {item.level}
                          </td>)}
                      </tr>
                    </tbody>
                  </table>
                </div>
              </div>

              {/* Cadet Female Section */}
              <div className="bg-white rounded-xl shadow-sm border border-gray-200 overflow-hidden" data-id="element-1034">
                <div className="bg-pink-600 px-6 py-4" data-id="element-1035">
                  <h2 className="text-xl font-bold text-white uppercase tracking-wide" data-id="element-1036">
                    Cadet FEMALE
                  </h2>
                </div>
                <div data-id="element-1037">
                  <table className="w-full text-xs md:text-sm text-center table-fixed" data-id="element-1038">
                    <tbody data-id="element-1039">
                      <tr className="border-b border-gray-200 bg-gray-50" data-id="element-1040">
                        <td className="px-2 py-3 font-bold text-gray-700 text-left w-20 md:w-28 border-r border-gray-200" data-id="element-1041">
                          Category
                        </td>
                        {cadetFemaleData.map((item, index) => <td key={index} className="px-1 py-3 text-gray-600 font-medium" data-id="element-1042">
                            {item.category}
                          </td>)}
                      </tr>
                      <tr className="border-b border-gray-200" data-id="element-1043">
                        <td className="px-2 py-3 font-bold text-gray-700 text-left bg-gray-50 w-20 md:w-28 border-r border-gray-200" data-id="element-1044">
                          Size
                        </td>
                        {cadetFemaleData.map((item, index) => <td key={index} className="px-1 py-3 font-bold text-red-600 text-sm md:text-lg" data-id="element-1045">
                            {item.size}
                          </td>)}
                      </tr>
                      <tr className="bg-gray-50" data-id="element-1046">
                        <td className="px-2 py-3 font-bold text-gray-700 text-left w-20 md:w-28 border-r border-gray-200" data-id="element-1047">
                          LEVEL
                        </td>
                        {cadetFemaleData.map((item, index) => <td key={index} className="px-1 py-3 font-bold text-gray-900 text-sm md:text-lg" data-id="element-1048">
                            {item.level}
                          </td>)}
                      </tr>
                    </tbody>
                  </table>
                </div>
              </div>
            </div> : selectedDivision === 'Kids Level' ? <div className="space-y-12" data-id="element-1049">
              {/* Kids 6-7 years */}
              <div className="bg-white rounded-xl shadow-sm border border-gray-200 overflow-hidden" data-id="element-1050">
                <div className="bg-green-600 px-6 py-4" data-id="element-1051">
                  <h2 className="text-xl font-bold text-white uppercase tracking-wide" data-id="element-1052">
                    Kids Level (6-7 years)
                  </h2>
                  <p className="text-green-100 text-sm mt-1" data-id="element-1053">
                    SIZE & HIT LEVEL - DAEDO PSS (2014)
                  </p>
                </div>
                <div data-id="element-1054">
                  <table className="w-full text-xs md:text-sm text-center table-fixed" data-id="element-1055">
                    <tbody data-id="element-1056">
                      <tr className="border-b border-gray-200 bg-gray-50" data-id="element-1057">
                        <td className="px-2 py-3 font-bold text-gray-700 text-left w-20 md:w-28 border-r border-gray-200" data-id="element-1058">
                          Category
                        </td>
                        {kids6to7Data.map((item, index) => <td key={index} className="px-1 py-3 text-gray-600 font-medium" data-id="element-1059">
                            {item.category}
                          </td>)}
                      </tr>
                      <tr className="border-b border-gray-200" data-id="element-1060">
                        <td className="px-2 py-3 font-bold text-gray-700 text-left bg-gray-50 w-20 md:w-28 border-r border-gray-200" data-id="element-1061">
                          Size
                        </td>
                        {kids6to7Data.map((item, index) => <td key={index} className="px-1 py-3 font-bold text-red-600 text-sm md:text-lg" data-id="element-1062">
                            {item.size}
                          </td>)}
                      </tr>
                      <tr className="bg-gray-50" data-id="element-1063">
                        <td className="px-2 py-3 font-bold text-gray-700 text-left w-20 md:w-28 border-r border-gray-200" data-id="element-1064">
                          LEVEL
                        </td>
                        {kids6to7Data.map((item, index) => <td key={index} className="px-1 py-3 font-bold text-gray-900 text-sm md:text-lg" data-id="element-1065">
                            {item.level}
                          </td>)}
                      </tr>
                    </tbody>
                  </table>
                </div>
              </div>

              {/* Kids 8-9 years */}
              <div className="bg-white rounded-xl shadow-sm border border-gray-200 overflow-hidden" data-id="element-1066">
                <div className="bg-teal-600 px-6 py-4" data-id="element-1067">
                  <h2 className="text-xl font-bold text-white uppercase tracking-wide" data-id="element-1068">
                    Kids Level (8-9 years)
                  </h2>
                  <p className="text-teal-100 text-sm mt-1" data-id="element-1069">
                    SIZE & HIT LEVEL - DAEDO PSS (2014)
                  </p>
                </div>
                <div data-id="element-1070">
                  <table className="w-full text-xs md:text-sm text-center table-fixed" data-id="element-1071">
                    <tbody data-id="element-1072">
                      <tr className="border-b border-gray-200 bg-gray-50" data-id="element-1073">
                        <td className="px-2 py-3 font-bold text-gray-700 text-left w-20 md:w-28 border-r border-gray-200" data-id="element-1074">
                          Category
                        </td>
                        {kids8to9Data.map((item, index) => <td key={index} className="px-1 py-3 text-gray-600 font-medium" data-id="element-1075">
                            {item.category}
                          </td>)}
                      </tr>
                      <tr className="border-b border-gray-200" data-id="element-1076">
                        <td className="px-2 py-3 font-bold text-gray-700 text-left bg-gray-50 w-20 md:w-28 border-r border-gray-200" data-id="element-1077">
                          Size
                        </td>
                        {kids8to9Data.map((item, index) => <td key={index} className="px-1 py-3 font-bold text-red-600 text-sm md:text-lg" data-id="element-1078">
                            {item.size}
                          </td>)}
                      </tr>
                      <tr className="bg-gray-50" data-id="element-1079">
                        <td className="px-2 py-3 font-bold text-gray-700 text-left w-20 md:w-28 border-r border-gray-200" data-id="element-1080">
                          LEVEL
                        </td>
                        {kids8to9Data.map((item, index) => <td key={index} className="px-1 py-3 font-bold text-gray-900 text-sm md:text-lg" data-id="element-1081">
                            {item.level}
                          </td>)}
                      </tr>
                    </tbody>
                  </table>
                </div>
              </div>

              {/* Kids 10-11 years */}
              <div className="bg-white rounded-xl shadow-sm border border-gray-200 overflow-hidden" data-id="element-1082">
                <div className="bg-emerald-600 px-6 py-4" data-id="element-1083">
                  <h2 className="text-xl font-bold text-white uppercase tracking-wide" data-id="element-1084">
                    Kids Level (10-11 years)
                  </h2>
                </div>
                <div data-id="element-1085">
                  <table className="w-full text-xs md:text-sm text-center table-fixed" data-id="element-1086">
                    <tbody data-id="element-1087">
                      <tr className="border-b border-gray-200 bg-gray-50" data-id="element-1088">
                        <td className="px-2 py-3 font-bold text-gray-700 text-left w-20 md:w-28 border-r border-gray-200" data-id="element-1089">
                          Category
                        </td>
                        {kids10to11Data.map((item, index) => <td key={index} className="px-1 py-3 text-gray-600 font-medium" data-id="element-1090">
                            {item.category}
                          </td>)}
                      </tr>
                      <tr className="border-b border-gray-200" data-id="element-1091">
                        <td className="px-2 py-3 font-bold text-gray-700 text-left bg-gray-50 w-20 md:w-28 border-r border-gray-200" data-id="element-1092">
                          Size
                        </td>
                        {kids10to11Data.map((item, index) => <td key={index} className="px-1 py-3 font-bold text-red-600 text-sm md:text-lg" data-id="element-1093">
                            {item.size}
                          </td>)}
                      </tr>
                      <tr className="bg-gray-50" data-id="element-1094">
                        <td className="px-2 py-3 font-bold text-gray-700 text-left w-20 md:w-28 border-r border-gray-200" data-id="element-1095">
                          LEVEL
                        </td>
                        {kids10to11Data.map((item, index) => <td key={index} className="px-1 py-3 font-bold text-gray-900 text-sm md:text-lg" data-id="element-1096">
                            {item.level}
                          </td>)}
                      </tr>
                    </tbody>
                  </table>
                </div>
              </div>
            </div> : selectedDivision === 'W.T.F. Olympic Category' ? <div className="space-y-12" data-id="element-1097">
              {/* Olympic Male Section */}
              <div className="bg-white rounded-xl shadow-sm border border-gray-200 overflow-hidden" data-id="element-1098">
                <div className="bg-blue-600 px-6 py-4" data-id="element-1099">
                  <h2 className="text-xl font-bold text-white uppercase tracking-wide" data-id="element-1100">
                    Senior MALE (남자)
                  </h2>
                </div>
                <div data-id="element-1101">
                  <table className="w-full text-xs md:text-sm text-center table-fixed" data-id="element-1102">
                    <tbody data-id="element-1103">
                      <tr className="border-b border-gray-200 bg-gray-50" data-id="element-1104">
                        <td className="px-2 py-3 font-bold text-gray-700 text-left w-20 md:w-28 border-r border-gray-200" data-id="element-1105">
                          Category
                        </td>
                        {olympicMaleData.map((item, index) => <td key={index} className="px-1 py-3 text-gray-600 font-medium" data-id="element-1106">
                            {item.category}
                          </td>)}
                      </tr>
                      <tr className="border-b border-gray-200" data-id="element-1107">
                        <td className="px-2 py-3 font-bold text-gray-700 text-left bg-gray-50 w-20 md:w-28 border-r border-gray-200" data-id="element-1108">
                          Size EBP
                        </td>
                        {olympicMaleData.map((item, index) => <td key={index} className="px-1 py-3 font-bold text-red-600 text-sm md:text-lg" data-id="element-1109">
                            {item.size}
                          </td>)}
                      </tr>
                      <tr className="bg-gray-50" data-id="element-1110">
                        <td className="px-2 py-3 font-bold text-gray-700 text-left w-20 md:w-28 border-r border-gray-200" data-id="element-1111">
                          LEVEL
                        </td>
                        {olympicMaleData.map((item, index) => <td key={index} className="px-1 py-3 font-bold text-gray-900 text-sm md:text-lg" data-id="element-1112">
                            {item.level}
                          </td>)}
                      </tr>
                    </tbody>
                  </table>
                </div>
              </div>

              {/* Olympic Female Section */}
              <div className="bg-white rounded-xl shadow-sm border border-gray-200 overflow-hidden" data-id="element-1113">
                <div className="bg-pink-600 px-6 py-4" data-id="element-1114">
                  <h2 className="text-xl font-bold text-white uppercase tracking-wide" data-id="element-1115">
                    Senior FEMALE (여자)
                  </h2>
                </div>
                <div data-id="element-1116">
                  <table className="w-full text-xs md:text-sm text-center table-fixed" data-id="element-1117">
                    <tbody data-id="element-1118">
                      <tr className="border-b border-gray-200 bg-gray-50" data-id="element-1119">
                        <td className="px-2 py-3 font-bold text-gray-700 text-left w-20 md:w-28 border-r border-gray-200" data-id="element-1120">
                          Category
                        </td>
                        {olympicFemaleData.map((item, index) => <td key={index} className="px-1 py-3 text-gray-600 font-medium" data-id="element-1121">
                            {item.category}
                          </td>)}
                      </tr>
                      <tr className="border-b border-gray-200" data-id="element-1122">
                        <td className="px-2 py-3 font-bold text-gray-700 text-left bg-gray-50 w-20 md:w-28 border-r border-gray-200" data-id="element-1123">
                          Size EBP
                        </td>
                        {olympicFemaleData.map((item, index) => <td key={index} className="px-1 py-3 font-bold text-red-600 text-sm md:text-lg" data-id="element-1124">
                            {item.size}
                          </td>)}
                      </tr>
                      <tr className="bg-gray-50" data-id="element-1125">
                        <td className="px-2 py-3 font-bold text-gray-700 text-left w-20 md:w-28 border-r border-gray-200" data-id="element-1126">
                          LEVEL
                        </td>
                        {olympicFemaleData.map((item, index) => <td key={index} className="px-1 py-3 font-bold text-gray-900 text-sm md:text-lg" data-id="element-1127">
                            {item.level}
                          </td>)}
                      </tr>
                    </tbody>
                  </table>
                </div>
              </div>
            </div> : selectedDivision === 'W.T.F. Para Taekwondo' ? <div className="space-y-12" data-id="element-1128">
              {/* Para Male Section */}
              <div className="bg-white rounded-xl shadow-sm border border-gray-200 overflow-hidden" data-id="element-1129">
                <div className="bg-blue-600 px-6 py-4" data-id="element-1130">
                  <h2 className="text-xl font-bold text-white uppercase tracking-wide" data-id="element-1131">
                    Senior MALE (남자)
                  </h2>
                </div>
                <div data-id="element-1132">
                  <table className="w-full text-xs md:text-sm text-center table-fixed" data-id="element-1133">
                    <tbody data-id="element-1134">
                      <tr className="border-b border-gray-200 bg-gray-50" data-id="element-1135">
                        <td className="px-2 py-3 font-bold text-gray-700 text-left w-20 md:w-28 border-r border-gray-200" data-id="element-1136">
                          Category
                        </td>
                        {paraMaleData.map((item, index) => <td key={index} className="px-1 py-3 text-gray-600 font-medium" data-id="element-1137">
                            {item.category}
                          </td>)}
                      </tr>
                      <tr className="border-b border-gray-200" data-id="element-1138">
                        <td className="px-2 py-3 font-bold text-gray-700 text-left bg-gray-50 w-20 md:w-28 border-r border-gray-200" data-id="element-1139">
                          Size EBP
                        </td>
                        {paraMaleData.map((item, index) => <td key={index} className="px-1 py-3 font-bold text-red-600 text-sm md:text-lg" data-id="element-1140">
                            {item.size}
                          </td>)}
                      </tr>
                      <tr className="bg-gray-50" data-id="element-1141">
                        <td className="px-2 py-3 font-bold text-gray-700 text-left w-20 md:w-28 border-r border-gray-200" data-id="element-1142">
                          LEVEL
                        </td>
                        {paraMaleData.map((item, index) => <td key={index} className="px-1 py-3 font-bold text-gray-900 text-sm md:text-lg" data-id="element-1143">
                            {item.level}
                          </td>)}
                      </tr>
                    </tbody>
                  </table>
                </div>
              </div>

              {/* Para Female Section */}
              <div className="bg-white rounded-xl shadow-sm border border-gray-200 overflow-hidden" data-id="element-1144">
                <div className="bg-pink-600 px-6 py-4" data-id="element-1145">
                  <h2 className="text-xl font-bold text-white uppercase tracking-wide" data-id="element-1146">
                    Senior FEMALE (여자)
                  </h2>
                </div>
                <div data-id="element-1147">
                  <table className="w-full text-xs md:text-sm text-center table-fixed" data-id="element-1148">
                    <tbody data-id="element-1149">
                      <tr className="border-b border-gray-200 bg-gray-50" data-id="element-1150">
                        <td className="px-2 py-3 font-bold text-gray-700 text-left w-20 md:w-28 border-r border-gray-200" data-id="element-1151">
                          Category
                        </td>
                        {paraFemaleData.map((item, index) => <td key={index} className="px-1 py-3 text-gray-600 font-medium" data-id="element-1152">
                            {item.category}
                          </td>)}
                      </tr>
                      <tr className="border-b border-gray-200" data-id="element-1153">
                        <td className="px-2 py-3 font-bold text-gray-700 text-left bg-gray-50 w-20 md:w-28 border-r border-gray-200" data-id="element-1154">
                          Size EBP
                        </td>
                        {paraFemaleData.map((item, index) => <td key={index} className="px-1 py-3 font-bold text-red-600 text-sm md:text-lg" data-id="element-1155">
                            {item.size}
                          </td>)}
                      </tr>
                      <tr className="bg-gray-50" data-id="element-1156">
                        <td className="px-2 py-3 font-bold text-gray-700 text-left w-20 md:w-28 border-r border-gray-200" data-id="element-1157">
                          LEVEL
                        </td>
                        {paraFemaleData.map((item, index) => <td key={index} className="px-1 py-3 font-bold text-gray-900 text-sm md:text-lg" data-id="element-1158">
                            {item.level}
                          </td>)}
                      </tr>
                    </tbody>
                  </table>
                </div>
              </div>
            </div> /* Coming Soon State for other divisions */ : <div className="bg-white rounded-xl shadow-sm border border-gray-200 p-12 text-center max-w-2xl mx-auto" data-id="element-1159">
              <div className="w-16 h-16 bg-blue-100 text-blue-600 rounded-full flex items-center justify-center mx-auto mb-6" data-id="element-1160">
                <svg className="w-8 h-8" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg" data-id="element-1161">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 8v4l3 3m6-3a9 9 0 11-18 0 9 9 0 0118 0z" data-id="element-1162" />
                </svg>
              </div>
              <h2 className="text-2xl font-bold text-gray-900 mb-3" data-id="element-1163">
                {selectedDivision} Data Coming Soon
              </h2>
              <p className="text-gray-600 text-lg" data-id="element-1164">
                We are currently updating our database with the latest
                thresholds and hit levels for this division. Please check back
                later.
              </p>
            </div>}
        </div>
      </main>

      <Footer data-id="element-1165" />
    </div>;
}